import React from 'react';
import IndividualPayslip from '../components/payslip/individualPayslip';

const IndividualPayslipPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      <IndividualPayslip />
    </div>
  );
};

export default IndividualPayslipPage;
